const anonymousNumber = "+266696687";

export default anonymousNumber;
